<template>
  <v-container>
      <!-- {{ formTitle }} -->
    <template >
      <v-toolbar flat color='cyan lighten-5' >          
        <v-toolbar-title  class="text-h5" > {{ formTitle }}</v-toolbar-title>         
      </v-toolbar>         
    </template>
    <v-data-table
      :headers="headers"
      :items="elvlist"   
      class="elevation-1"
  >       
      
      <template #[`item.itmEvl`]="{ item }">
          <v-chip
              small
            :color="getColor(item.itmEvl)"
            dark
          >
            {{ item.itmEvl }}
          </v-chip>
      </template>

      <template #[`item.enm`]="{ item }">
          <v-chip class="ma-2" color="indigo" text-color="white" small
          > {{ item.id }} 
          </v-chip>
          <v-chip class="ma-2" color="indigo" text-color="white" small
          > {{ item.enm }} 
          </v-chip>
      </template>

      <template v-slot:item.itm01="{ item }">
        <v-text-field v-model="editedItem.itm01" dense single-line type="number" :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
        <span v-else>{{item.itm01}}</span>
      </template> 

      <template v-slot:item.itm02="{ item }">
        <v-text-field v-model="editedItem.itm02" dense single-line type="number" :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
        <span v-else>{{item.itm02}}</span>
      </template> 

      <template v-slot:item.itm03="{ item }">
        <v-text-field v-model="editedItem.itm03" dense single-line type="number" :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
        <span v-else>{{item.itm03}}</span>
      </template> 

      <template v-slot:item.itm04="{ item }">
        <v-text-field v-model="editedItem.itm04" dense single-line type="number" :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
        <span v-else>{{item.itm04}}</span>
      </template> 

      <template v-slot:item.itm05="{ item }">
        <v-text-field v-model="editedItem.itm05" dense single-line type="number" :autofocus="true" v-if="item.effEmpno === editedItem.effEmpno"></v-text-field>
        <span v-else>{{item.itm05}}</span>
      </template> 

      <template v-slot:item.actions="{ item }">
          <div v-if="item.effEmpno === editedItem.effEmpno">
            <v-icon color="red" class="mr-3" @click="closeEff">
              mdi-window-close
            </v-icon>
            <v-icon color="green" @click="saveEff">
              mdi-content-save
            </v-icon>        
          </div>
          <div v-else>
            <v-icon color="green" class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>           
          </div>
          <v-btn  
          class="mt-1"              
          x-small
          color="primary"
          dark
          @click="refItem(item)"
        >
          Ref. Info
        </v-btn>
      </template>

        <!--Reference Information -->
      <template v-slot:top>          
          <v-dialog 
            v-model="dialogRef"                  
            scrollable
            persistent
            transition="dialog-bottom-transition"
            >
            <v-card>
              <v-card-title class="d-flex cyan darken-1">
                <v-chip class="ma-2" color="orange">
                  {{refEnm}}  Ref. Info
                </v-chip>              
                <v-spacer></v-spacer>

                <v-btn  dark  icon
                  @click="closeRef"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text >
                <DxScrollView  height="100%" width="100%">
                  <v-data-table
                      :mobile-breakpoint="800"
                      :mobile="mobile"
                      :items-per-page="5"
                      :headers="dialogRefheaders"
                      :items="dialogelvReflist"
                      :sort-by="[]"
                      :sort-desc="[false]"
                      hide-default-footer
                      dense
                      :dark="false"
                    >
                  </v-data-table>  
                </DxScrollView>   
              </v-card-text>              
            </v-card>          
          </v-dialog>
      </template>
    </v-data-table>  

    <VueToastify :notifyAction="notifyAction"></VueToastify>    
    <!--End Reference Information -->                 

    <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="green" @click="toTop">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>

   </v-container> 
   
 
</template>

<script>

import { DxScrollView } from "devextreme-vue/scroll-view";
import {getEvlHeader, getEvlDetails, getEvlRef, chkEvlGap, updateEvl} from '@/api/view/mis/10/v10a3000.js' 
import VueToastify from '@/components/toastify/VueToastify.vue'
import baseview from '@/components/base/baseview.vue'

export default {
  mixins: [baseview],
  components: { 
      VueToastify,   
      DxScrollView             
    },
    
  data: () => ({    
    dialogRef:false,
    headers: [],    
    dialogRefheaders: [      
      { text: 'Efficiency(0)', sortable: false, value: 'effMrk' },
      { text: 'IR  (0)', sortable: false, value: 'ir' },
      { text: 'HSE (+/-)', sortable: false, value: 'hseScr' },
      { text: 'Contest Reward', sortable: false, value: 'contestRw' },
      { text: 'Excellent Year', sortable: false, value: 'exYr' },
      { text: 'Reward', sortable: false, value: 'rw' },
      { text: 'Discipline', sortable: false, value: 'ddsp' },
      { text: 'Diligence:', sortable: false, value: 'ddlg' },      

    ],
    
    dialogScrheaders: [],
    mobile: true,
    elvlist: [],
    elvlistScr: [],
    dialogelvReflist:[],
    editedIndex: -1,
    refEnm:'',
    editedItem: {
      effEmpno:'',
      name: '',
      itm01: 0,
      itm02: 0,
      itm03: 0,
      itm04: 0,
      itm05: 0
    },
    defaultItem: {
      effEmpno:'',
      name: '',
      itm01: 0,
      itm02: 0,
      itm03: 0,
      itm04: 0,
      itm05: 0,
    },
    maxEvl:0,
    minEvl:0,
    evlYr: 0,
    evlSrl: '',
    fab: false,
  }),

  computed: {
    formTitle () {
      let frmTle = '';
      var date = new Date();    

      if (date.getMonth() < 6) {
        frmTle = 'I'             
      } 
      else
      {
        frmTle = 'II'        
      }
      return 'Evaluation Term: ' + frmTle + '/' + date.getFullYear();
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.assignEvl()
      this.getEvaluationList()      
    },
    
    assignEvl () {
    
    var date = new Date();    

    if (date.getMonth() < 6) {       
     
      this.evlYr = date.getFullYear();
      this.evlSrl = '1'; 
    } 
    else
    {
      this.evlYr = date.getFullYear();
      this.evlSrl = '2';   
    }
  },

    //getEvaluationList
    async getEvaluationList() {        
      
        
        try {
            // this.openLoading('searching')
            let params = {
                        evlYr: this.evlYr.toString(),
                        evlSrl: this.evlSrl,
                        // userId: '700622'
                         userId: this.$store.state.user.userId,              
                      }

              await getEvlHeader(params).then(res => {
                let list = []
                let cnt = 1;
                
                list.push(
                    {
                        text: 'Full Name',
                        align: 'start',
                        sortable: false,
                        value: 'enm',
                        divider: true,  
                                             
                      }
                   )
                  res.list.forEach(e => {
                    list.push(
                    {
                      id: cnt++, text: e.itmConte + ' (' + e.itmGrd + ')', sortable: false, value: 'itm'+ e.itmNo , 
                      divider: true,align: 'start',     
                    }
                  )               
                  });
                  list.push(
                  {
                    id: cnt++,  text: 'Total',  value: 'itmEvl', sortable: false,  divider: true,                                                   
                  }
                )   
                list.push(
                  {
                    id: cnt++,  text: 'Edit & Ref.',  value: 'actions', sortable: false,  divider: true,                                                   
                  }
                )                
                  this.headers = list      
                  // console.log(this.headers)            
                })
  
              await getEvlDetails(params).then(res => {
                let list = []
                let cnt = 1;                
                res.list.forEach(e => {
                  list.push(
                  {
                     id: cnt++, enm: e.enm, effEmpno:e.effEmpno, grpCd: e.grpCd, itmPos:e.itmPos,
                     itm01: e.itm01, itm02: e.itm02, itm03: e.itm03, itm04: e.itm04, itm05: e.itm05, itmEvl: e.totalEvl,                     
                     grd01: e.grd01, grd02: e.grd02, grd03: e.grd03, grd04: e.grd04, grd05:e.grd05      
      
                  }
                )              
                  });
                  this.elvlist = list
                  // console.log(this.elvlist)         
                })

                await chkEvlGap(params).then(res => {                        
                res.list.forEach(e => {
                    this.maxEvl = res.list[0].maxEvl
                    this.minEvl = res.list[0].minEvl                   

                  });                  
                  
                })


            } finally {                
                // this.endLoading()
            }

      },

    getColor (totalEvl) {

        if (totalEvl > 90) return 'green'
        else if (totalEvl >= 80) return 'orange'
        else return 'red'
      },  

    refItem (item) {            

        this.refEnm = item.enm

        let params = {
              evlYr: this.evlYr.toString(),
              evlSrl: this.evlSrl,
             // userId: '700622', 
               //this.$store.state.user.userId,                            
              effEmpno: item.effEmpno
            } 

           getEvlRef(params).then(res => {
                let list = []
                let cnt = 1;                
                res.list.forEach(e => {
                  list.push(
                  {

                   id: cnt++, effMrk: e.effMrk, ir: e.ir, hseScr: e.hseScr, rw: e.rw, ddsp: e.ddsp, ddlg: e.ddlg,
                      contestRw: e.contestRw, exYr: e.exYr 
      
                  }
                )              
                  });
                  this.dialogelvReflist = list
                  //  console.log(this.dialogelvReflist)
                })

      this.dialogRef = true      
    },

    editItem (item) {
      
      this.editedIndex = this.elvlist.indexOf(item);      
      this.editedItem = Object.assign({}, item);      

    },

    closeRef () {
      this.dialogRef = false      
    },

    closeEff () {      
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
   
    saveEff () {    
      
      // console.log(this.editedItem)

      let sumEvl = 0
      let params = [];
      let savebl = true

      if ((parseInt(this.editedItem.grd01) < parseInt(this.editedItem.itm01)) || (parseInt(this.editedItem.grd02) < parseInt(this.editedItem.itm02))
          ||(parseInt(this.editedItem.grd03) < parseInt(this.editedItem.itm03))|| (parseInt(this.editedItem.grd04) < parseInt(this.editedItem.itm04)) 
          ||(parseInt(this.editedItem.grd05) < parseInt(this.editedItem.itm05)))
      {
        
        this.vToastify(this.$t('Please check your evaluation score.'), 'warn') 
         
      }
      else{

        sumEvl = parseInt(this.editedItem.itm01) + parseInt(this.editedItem.itm02) + parseInt(this.editedItem.itm03)
               + parseInt(this.editedItem.itm04) + parseInt(this.editedItem.itm05)
        
        if ((this.maxEvl -  sumEvl > 20) || ( sumEvl - this.minEvl> 20))
        {
          this.vToastify(this.$t('Please check total score.'), 'warn') 
          savebl = false
        }  
        else if (( sumEvl < this.minEvl) && (this.maxEvl -  sumEvl <= 20))
        {
          this.minEvl =  sumEvl
        }  
        else if (( sumEvl > this.maxEvl) && ( sumEvl - this.minEvl <= 20))
        {
          this.maxEvl =  sumEvl
        }  
       
        if (this.maxEvl = this.minEvl && this.maxEvl > 0 ) 
        {
          this.vToastify(this.$t('You must give the gap at the total score at least 1 person in the evaluation list'), 'warn') 
          savebl = false
        }  
       
        if (savebl) {

          //------------------------
            for(let i = 0; i < 5; i++) {
                let prs = {}
                 
                // evlSrl: this.evlSrl,
                prs.evlYr = this.evlYr.toString(),
                prs.evlSrl = '2'
                prs.evlEmpno = this.$store.state.user.userId
                prs.effEmpno = this.editedItem.effEmpno
                prs.itmPos = this.editedItem.itmPos
                prs.grpCd = this.editedItem.grpCd              
                prs.itmNo = '0'+ (i+1)
                params.push(prs) 
            }
            params[0].evlRst = this.editedItem.itm01
            params[1].evlRst = this.editedItem.itm02
            params[2].evlRst = this.editedItem.itm03
            params[3].evlRst = this.editedItem.itm04
            params[4].evlRst = this.editedItem.itm05

            
            //console.log('params', params)

            updateEvl(params).then(res => {
            //console.log('res', res)

              const msg = res.body

              if(msg === 'Y') {
                this.vToastify(this.$t("Update successfully!"), 'warn')
                this.getEvaluationList()
              } else {
                this.vToastify(this.$t("An error has occured while updating data to ...."), 'warn')
              }
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              // this.endLoading()
            })
            // ------------------------
        }  

          if (this.editedIndex > -1) {
            Object.assign(this.elvlist[this.editedIndex], this.editedItem)
          } else {
            this.elvlist.push(this.editedItem)
          }          
        }  

        this.closeEff()  
    },


    onScroll(e) {
          if (typeof window === 'undefined') return
          const top = window.pageYOffset || e.target.scrollTop || 0
          this.fab = top > 20
        },
        toTop() {
          this.$vuetify.goTo(0)
      },


    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },

  },
}
</script>

<style >
  .v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__prefix, .v-text-field.v-input--dense:not(.v-text-field--outlined) .v-text-field__suffix, .v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    padding: 4px 0 2px;
    text-align: right;
    width: 50px;
}
</style>